





























































import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

interface PromotorOption {
  value: number;
  text: string;
  nbProgrammesDiffuses?: number;
}

@Component({})
export default class PromotorSearchComponent extends Vue {
  @Prop({ default: () => [] }) fetch!: (value: string) => Promise<PromotorOption[]>;
  @Prop() placeholder!: string;
  @Prop() notFoundContent!: string;
  @Prop({ default: false }) dropDownMatchSelectWidth!: boolean;
  @Model('update:value') readonly value!: number | undefined;

  vModel: number | undefined = undefined;
  searching = false;
  hasSearched = false;
  items: PromotorOption[] = [];
  fetchSeq = 0;
  debouncedFetchElements = debounce(this.fetchElements, 300);

  @Watch('value')
  onValue() {
    this.vModel = this.value;
  }

  onSearch(value: string) {
    this.debouncedFetchElements(value);
  }

  async fetchElements(value: string) {
    const seq = ++this.fetchSeq;
    this.searching = true;
    try {
      const results = await this.fetch(value);
      if (seq !== this.fetchSeq) return; // stale response — a newer request is in flight
      this.items = results;
      this.hasSearched = (value || '').length >= 3;
    } finally {
      if (seq === this.fetchSeq) {
        this.searching = false;
      }
    }
  }

  onChange(value: number | undefined) {
    this.$emit('update:value', value);
    this.$emit('change', value);
  }

  async mounted() {
    this.vModel = this.value;
    await this.fetchElements(this.vModel ? String(this.vModel) : '');
    if (this.vModel && this.items.length === 1) {
      this.$emit('change', this.items[0].value);
    }
  }

  clear() {
    this.vModel = undefined;
    this.items = [];
    this.hasSearched = false;
    this.$emit('update:value', undefined);
    this.$emit('change', undefined);
  }
}
